import type {UseTableHooks} from 'react-table'

import type {V7Column} from '../../hooks/tanstack-table/types'
import {RowDragHandleColumnId} from './column-ids'
import RowDragger from './row-dragger'
import type {CellEditorRenderProps, CellRenderProps} from './state-providers/table-columns/types'
import type {TableDataType} from './table-data-type'

export const ROW_DRAG_HANDLE_WIDTH = 60

const rowDragHandle = {
  Header: '',
  id: RowDragHandleColumnId,
  width: ROW_DRAG_HANDLE_WIDTH,
  nonNavigable: true,
  canReorder: false,
  Cell(props: CellRenderProps) {
    return <RowDragger row={props.row} />
  },
  // workaround for first column and cell not having a CellEditor component defined
  // revisit when we look at keyboard navigation to better understand what is required for
  // our row reordering functionality
  CellEditor(props: CellEditorRenderProps) {
    return <RowDragger row={props.row} />
  },
} as V7Column<TableDataType>

/**
 * @deprecated - this v7 plugin is being migrated to a v8 feature that
 * does not require this method.
 * Issue: https://github.com/github/memex/issues/20696
 */
// eslint-disable-next-line @eslint-react/hooks-extra/no-unnecessary-use-prefix
function useColumns(columns: Array<V7Column<TableDataType>>): Array<V7Column<TableDataType>> {
  const newColumns = [rowDragHandle, ...columns]
  return newColumns
}

/**
 * @deprecated - this v7 plugin is being migrated to a v8 feature that
 * does not require this hook.
 * Issue: https://github.com/github/memex/issues/20696
 */
// eslint-disable-next-line @eslint-react/hooks-extra/no-unnecessary-use-prefix
export const useRowDragHandle = (hooks: UseTableHooks<TableDataType>) => {
  hooks.columns.unshift(useColumns)
}

useRowDragHandle.pluginName = 'useRowDragHandle'
